import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import BreadcrumbBlock from "../../../components/common/Breadcrumb";
import csvDownload from "json-to-csv-export";
import download from "downloadjs";
import Moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getFileCSVData } from "../../../context/actions/document";
import { pagination } from "../../../utils/constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig } from "../../../utils/constants";
import "./index.scss";
import CsvModal from "./CsvModal/CsvModal";
import Alerts from "../../../components/common/Alerts";
toast.configure();

const DashboardHeader = ({
  totalFilesProcessedToday,
  totalFilesProcessedYesterday,
  totalFilesEditedToday,
  totalFilesEditedYesterday,
  averageComputeTimeToday,
  averageComputeTimeYesterday,
}) => {
  const [showWelcomeMessage, setShowWelcomeMessage] = useState();
  const welcomeMessage = useSelector((state) => state?.user?.showWelcomeMessage);
  useEffect(() => {
    setShowWelcomeMessage(welcomeMessage ? true : false);
  }, [welcomeMessage]);
  const dispatch = useDispatch();
  const [showModel, setShowModel] = useState(false);

  let mockData = [
    {
      "FILES PROCESSED TODAY": totalFilesProcessedToday
        ? totalFilesProcessedToday
        : "0",
      "FILES PROCESSED YESTERDAY": totalFilesProcessedYesterday
        ? totalFilesProcessedYesterday
        : "0",
      "MANUALLY CHECKED ITEMS TODAY": totalFilesEditedToday
        ? totalFilesEditedToday
        : "0",
      "MANUALLY CHECKED ITEMS YESTERDAY": totalFilesEditedYesterday
        ? totalFilesEditedYesterday
        : "0",
      "AVG. COMPUTE TIME TODAY": averageComputeTimeToday
        ? averageComputeTimeToday / 1000 + "s"
        : "0",
      "AVG. COMPUTE TIME YESTERDAY": averageComputeTimeYesterday
        ? averageComputeTimeYesterday / 1000 + "s"
        : "0",
    },
  ];
  let currentDate = Moment().format("YYYY-MM-D");
  let filename = currentDate + "-report.csv";
  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const downloadCSV = async (url, name) => {
    const response = await fetch(url);
    const data = await response.text();
    const blob = new Blob([data], { type: "data:text/csv;charset=utf-8," });
    const blobURL = window.URL.createObjectURL(blob);

    // Create new tag for download file
    const anchor = document.createElement("a");
    anchor.download = name;
    anchor.href = blobURL;
    anchor.dataset.downloadurl = [
      "text/csv",
      anchor.download,
      anchor.href,
    ].join(":");
    anchor.click();

    // Remove URL.createObjectURL. The browser should not save the reference to the file.
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      URL.revokeObjectURL(blobURL);
    }, 100);
  };

  const csvDataDownload = () => {
    const dates = new Date();
    const fileNames =
      formatDate(dates) + /*dates.getTime() + 'csvlogs.csv'*/ ".csv";
    dispatch(
      getFileCSVData({ limit: pagination.maxlimit }, async (response) => {
        if (response.blobPDFUrl) {
          downloadCSV(response.blobPDFUrl, fileNames);
        } else {
          toast.error(response.message, toasterConfig);
        }
      })
    );
  };

  const show = () => {
    setShowModel(true);
  };
  const closeModal = () => {
    setShowModel(false);
  };
  return (
    <>
      {/* Modal to open and select date range then  download csv file */}
      <CsvModal showModel={showModel} closeModal={closeModal} />
      <div className="dashboard-header d-flex align-items-center">
        <div className="left-col">
          <BreadcrumbBlock />
          {/* <h2>Welcome to Dashboard</h2> */}
        </div>
        {showWelcomeMessage && (
          <div className="right-col btns-blc d-flex align-items-center ms-auto">
            <Alerts />
            {/* <h2>Welcome to Dashboard</h2> */}
          </div>
        )}

        <div className="right-col btns-blc d-flex align-items-center ms-auto">
          {/* <Button color="link" className="email-btn">
						<span className="d-inline-flex align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="16.002" height="12" viewBox="0 0 16.002 12">
								<path id="Mail" d="M14.5,8H1.5A1.5,1.5,0,0,0,0,9.5v9A1.5,1.5,0,0,0,1.5,20h13A1.5,1.5,0,0,0,16,18.5v-9A1.5,1.5,0,0,0,14.5,8Zm1,10.278-4.73-4.73,4.73-3.014ZM1.5,8.5h13a1,1,0,0,1,1,1v.442L8.614,14.328A1.1,1.1,0,0,1,7.4,14.311L.5,9.617V9.5A1,1,0,0,1,1.5,8.5Zm-1,1.721,4.8,3.26-4.8,4.8Zm14,9.279H1.5a1,1,0,0,1-.919-.607l5.13-5.13,1.414.961a1.6,1.6,0,0,0,1.761.026l1.461-.931,5.074,5.074A1,1,0,0,1,14.5,19.5Z" transform="translate(0.003 -8)" fill="#5f6c81" />
							</svg>
						</span>
						EMAIL
					</Button>
					<Button color="link" className="print-btn" onClick={() => window.print()}>
						<span className="d-inline-flex align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="15.627" height="14.665" viewBox="0 0 15.627 14.665">
								<g id="Printer" transform="translate(0 -1.969)">
									<path id="Path_16" data-name="Path 16" d="M14.11,4.914H12.819V2.945a.977.977,0,0,0-.977-.977H3.785a.977.977,0,0,0-.977.977V4.914H1.517A1.519,1.519,0,0,0,0,6.431v6.415a1.519,1.519,0,0,0,1.517,1.517H2.1a.244.244,0,0,0,0-.488H1.517A1.03,1.03,0,0,1,.488,12.845V6.431A1.03,1.03,0,0,1,1.517,5.4H14.11a1.03,1.03,0,0,1,1.028,1.028v6.415a1.03,1.03,0,0,1-1.028,1.028h-.437a.244.244,0,0,0,0,.488h.437a1.519,1.519,0,0,0,1.517-1.517V6.431A1.519,1.519,0,0,0,14.11,4.914ZM3.3,2.945a.489.489,0,0,1,.488-.488h8.058a.489.489,0,0,1,.488.488V4.9H3.3Z" transform="translate(0 0)" fill="#5f6c81" />
									<path id="Path_17" data-name="Path 17" d="M25.1,45.032H19.245a.244.244,0,0,0,0,.488H25.1a.244.244,0,0,0,0-.488Z" transform="translate(-14.361 -32.549)" fill="#5f6c81" />
									<path id="Path_18" data-name="Path 18" d="M25.1,52.032H19.245a.244.244,0,0,0,0,.488H25.1a.244.244,0,0,0,0-.488Z" transform="translate(-14.361 -37.839)" fill="#5f6c81" />
									<circle id="Ellipse_11" data-name="Ellipse 11" cx="0.488" cy="0.488" r="0.488" transform="translate(1.455 6.333)" fill="#5f6c81" />
									<circle id="Ellipse_12" data-name="Ellipse 12" cx="0.488" cy="0.488" r="0.488" transform="translate(3 6.333)" fill="#5f6c81" />
									<circle id="Ellipse_13" data-name="Ellipse 13" cx="0.488" cy="0.488" r="0.488" transform="translate(4.545 6.333)" fill="#5f6c81" />
									<path id="Path_19" data-name="Path 19" d="M11,42.379H21.256V36.031H11Zm.587-5.761h9.082v5.174H11.587Z" transform="translate(-8.315 -25.745)" fill="#5f6c81" />
								</g>
							</svg>

						</span>
						PRINT
					</Button> */}

          {/* <Button color="secondary" n onClick={() => csvDownload(mockData, filename)} className="report-btn">

						<span className="d-inline-flex align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="11.999" height="15.367" viewBox="0 0 11.999 15.367">
								<path id="file" d="M68,3.331c0-.006,0-.011,0-.016V3.309c0-.006,0-.013,0-.019v0l-.007-.019v0l-.008-.017v0l-.009-.015,0,0-.01-.013,0,0-.014-.015h0L64.805.066l0,0L64.789.051l-.005,0L64.771.038l0,0L64.752.027l0,0L64.732.017h0L64.712.01h0L64.69,0h-.006l-.016,0H57.188A1.189,1.189,0,0,0,56,1.188V14.179a1.189,1.189,0,0,0,1.188,1.188h9.623A1.189,1.189,0,0,0,68,14.179V3.353Q68,3.342,68,3.331ZM64.871.77l2.358,2.358H65.608a.738.738,0,0,1-.737-.737Zm1.94,14.146H57.188a.738.738,0,0,1-.737-.737V1.188a.738.738,0,0,1,.737-.737H64.42v1.94a1.189,1.189,0,0,0,1.188,1.188h1.94v10.6A.738.738,0,0,1,66.811,14.916Z" transform="translate(-56)" />
							</svg>
						</span>
						GENERATE REPORT
					</Button>
					{<Button color="secondary"  onClick={() => csvDataDownload()} className="report-btn">

						<span className="d-inline-flex align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="11.999" height="15.367" viewBox="0 0 11.999 15.367">
								<path id="file" d="M68,3.331c0-.006,0-.011,0-.016V3.309c0-.006,0-.013,0-.019v0l-.007-.019v0l-.008-.017v0l-.009-.015,0,0-.01-.013,0,0-.014-.015h0L64.805.066l0,0L64.789.051l-.005,0L64.771.038l0,0L64.752.027l0,0L64.732.017h0L64.712.01h0L64.69,0h-.006l-.016,0H57.188A1.189,1.189,0,0,0,56,1.188V14.179a1.189,1.189,0,0,0,1.188,1.188h9.623A1.189,1.189,0,0,0,68,14.179V3.353Q68,3.342,68,3.331ZM64.871.77l2.358,2.358H65.608a.738.738,0,0,1-.737-.737Zm1.94,14.146H57.188a.738.738,0,0,1-.737-.737V1.188a.738.738,0,0,1,.737-.737H64.42v1.94a1.189,1.189,0,0,0,1.188,1.188h1.94v10.6A.738.738,0,0,1,66.811,14.916Z" transform="translate(-56)" />
							</svg>
						</span>
						GENERATE CSV
					</Button>} */}
          {
            <Button
              color="secondary"
              onClick={() => show()}
              className="report-btn"
            >
              <span className="d-inline-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11.999"
                  height="15.367"
                  viewBox="0 0 11.999 15.367"
                >
                  <path
                    id="file"
                    d="M68,3.331c0-.006,0-.011,0-.016V3.309c0-.006,0-.013,0-.019v0l-.007-.019v0l-.008-.017v0l-.009-.015,0,0-.01-.013,0,0-.014-.015h0L64.805.066l0,0L64.789.051l-.005,0L64.771.038l0,0L64.752.027l0,0L64.732.017h0L64.712.01h0L64.69,0h-.006l-.016,0H57.188A1.189,1.189,0,0,0,56,1.188V14.179a1.189,1.189,0,0,0,1.188,1.188h9.623A1.189,1.189,0,0,0,68,14.179V3.353Q68,3.342,68,3.331ZM64.871.77l2.358,2.358H65.608a.738.738,0,0,1-.737-.737Zm1.94,14.146H57.188a.738.738,0,0,1-.737-.737V1.188a.738.738,0,0,1,.737-.737H64.42v1.94a1.189,1.189,0,0,0,1.188,1.188h1.94v10.6A.738.738,0,0,1,66.811,14.916Z"
                    transform="translate(-56)"
                  />
                </svg>
              </span>
              GENERATE CSV
            </Button>
          }
        </div>
      </div>
    </>
  );
};
export default DashboardHeader;
